var map = {
	"./DpShowSerialNumber_Isabel_8.png": 77,
	"./animated_step1_en.gif": 635,
	"./animated_step1_fr.gif": 59,
	"./animated_step1_nl.gif": 317,
	"./animated_step2_en.gif": 735,
	"./animated_step2_fr.gif": 844,
	"./animated_step2_nl.gif": 430,
	"./animated_step3_en.gif": 210,
	"./animated_step3_fr.gif": 444,
	"./animated_step3_nl.gif": 199,
	"./animated_step4_en.gif": 530,
	"./animated_step4_fr.gif": 710,
	"./animated_step4_nl.gif": 741,
	"./cameraPlay.png": 170,
	"./cameraStop.png": 242,
	"./isabelsmartcard.png": 307,
	"./isakey-power-button.png": 637,
	"./isakey.png": 790,
	"./isakey.svg": 230,
	"./itsme.png": 300,
	"./itsme.svg": 475,
	"./notfound.png": 333,
	"./onespandigipass.png": 885,
	"./smartcard.svg": 926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;